import { AuthFacade } from '@core/services/auth-facade';
import { shouldRelogin } from '@core/utils/auth-errors';
import { environment } from '@environments/environment';

export const enum AuthAccessResult {
  Allowed = 'allowed',
  RedirectedToLogin = 'redirected_to_login',
  TemporaryFailure = 'temporary_failure',
}

export async function ensureAuthAccess(
  auth: AuthFacade,
  isAuthenticated: boolean,
  returnTo: string,
): Promise<AuthAccessResult> {
  if (!isAuthenticated) {
    await auth.login({ returnTo });
    return AuthAccessResult.RedirectedToLogin;
  }

  try {
    await auth.getToken(environment.auth0.audience);
  } catch (error) {
    if (shouldRelogin(error)) {
      await auth.login({ returnTo, promptLogin: true });
      return AuthAccessResult.RedirectedToLogin;
    }

    return AuthAccessResult.TemporaryFailure;
  }

  return AuthAccessResult.Allowed;
}
